module.exports = __webpack_public_path__ + "static/media/ic_check_sel.701f5b28.svg";